import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router';

import { FullPageLoader } from './components/layout/loading';
import { ProtectedRoute } from './components/layout/ProtectedRoute';
import { AppLayout } from './components/layout/app-layout';

const Login = lazy(() => import('./pages/auth/login'));
const VerifyOtp = lazy(() => import('./pages/auth/verify'));
const CreateOrganization = lazy(() => import('./pages/auth/create-organization'));
const AddOrganization = lazy(() => import('./pages/auth/add-organization'));
const SelectOrganization = lazy(() => import('./pages/auth/select-organization'));
const Dashboard = lazy(() => import('./pages/index'));
const Settings = lazy(() => import('./pages/settings'));
const PartsList = lazy(() => import('./pages/parts/index'));
const Orders = lazy(() => import('./pages/orders/index'));
const ImportParts = lazy(() => import('./pages/parts/import'));
const PartDetail = lazy(() => import('./pages/parts/[id]'));
const Storefront = lazy(() => import('./pages/storefront/index'));
const Membership = lazy(() => import('./pages/membership/index'));
const OrderDetail = lazy(() => import('./pages/orders/[id]'));
const Rfqs = lazy(() => import('./pages/rfqs/index'));
const NewRfq = lazy(() => import('./pages/rfqs/new-rfq'));
const RfqDetail = lazy(() => import('./pages/rfqs/[id]'));
const Messages = lazy(() => import('./pages/messages/index'));
const QuoteDetail = lazy(() => import('./pages/quotes/[id]'));
const OrderManagementDetail = lazy(() => import('./pages/orders/management/[id]'));
const CheckoutReturn = lazy(() => import('./pages/checkout/index'));

export function AppRoutes() {
  return (
    <Suspense fallback={<FullPageLoader />}>
      <Routes>
        <Route path="/auth" Component={Login} />
        <Route path="/auth/verify" Component={VerifyOtp} />

        <Route element={<ProtectedRoute />}>
          <Route path="/onboarding/create-organization" element={<CreateOrganization />} />
          <Route path="/onboarding/add-organization" element={<AddOrganization />} />
          <Route path="/onboarding/select-organization" element={<SelectOrganization />} />

          <Route element={<AppLayout />}>
            <Route path="/" Component={Dashboard} />
            <Route path="/storefront" Component={Storefront} />
            <Route path="/parts" Component={PartsList} />
            <Route path="/parts/import" Component={ImportParts} />
            <Route path="/parts/:id" Component={PartDetail} />
            <Route path="/orders" Component={Orders} />
            <Route path="/orders/:id" Component={OrderDetail} />
            <Route path="/quotes" element={<Navigate to="/rfqs" replace />} />
            <Route path="/quotes/:id" Component={QuoteDetail} />
            <Route path="/checkout" Component={CheckoutReturn} />
            <Route path="/rfqs" Component={Rfqs} />
            <Route path="/rfqs/new-rfq" Component={NewRfq} />
            <Route path="/rfqs/:id" Component={RfqDetail} />
            <Route path="/messages" Component={Messages} />
            <Route path="/orders/management/:id" Component={OrderManagementDetail} />
            <Route path="/settings" Component={Settings} />

            <Route path="/membership" Component={Membership} />
          </Route>
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
}
